import { createFileRoute } from "@tanstack/react-router";
import { ForgotPasswordComponent } from "../../features/auth/components/ForgotPasswordComponent";

export const Route = createFileRoute("/_auth/forgot-password")({
  validateSearch: (search) => ({
    redirect: search.redirect,
  }),
  component: ForgotPasswordComponent,
});